import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <React.Fragment>
      <>
      <div class="forline">
Start Your Move Today. Call Us <a href="tel:02039277675">020 3927 7675</a>
  </div>



  <footer id="rs-footer" class="rs-footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-12 col-sm-12 footer-widget-one md-mb-50">
            <div class="about-widget">
              <a href="/">
                <img src="https://southlondonremovals.uk/images/logo2.png" />
              </a>
              <div class="footer-info">
                <p class="footer-desc">
                  South London Removals was founded on the principles of giving customers a friendly, professional and helpful moving service, tailored to our customers' needs.
South London Removals is a brand of SLRD Ltd, a company registered in England and Wales - Registered No. 15066026
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12 footer-widget-two md-mb-50">
            <h5 class="footer-title">Contact Us</h5>

            <ul class="footer-address p-0 mt-4">
              <li class="d-flex">

                <span>
                  <i class="fa-solid fa-location-dot" ></i>
                  25 Cabot Square, Canary Wharf, Greater London E14 4QZ, United Kingdom
                </span>
              </li>
              <li class="d-flex">

                <a href="tel:02072590229"> <i class="fas fa-phone"></i>020 3927 7675</a>
              </li>
              <li class="d-flex">

                <a href="mailto:contact@southlondonremovals.uk"><i class="fas fa-envelope"></i>contact@southlondonremovals.uk</a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-12 col-sm-12 footer-widget-three md-mb-50">
            <h5 class="footer-title">Our Services</h5>
            <div class="f-link">
              <ul class="p-0 m-0">
                <li>
                  <a href="https://southlondonremovals.uk/home-removals-london/">UK Home Moves</a>
                </li>
                <li>
                  <a href="https://southlondonremovals.uk/business-movers-london/">UK Business Moves</a>
                </li>
                <li>
                  <a href="https://southlondonremovals.uk/international-movers/">
                  International Move
                  </a>
                </li>
                <li>
                  <a href="https://southlondonremovals.uk/storage-services-london/">
                  Storage Services
                  </a>
                </li>

              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-12 col-sm-12 footer-widget-four">
            <h5 class="footer-title">Key Links</h5>
            <div class="f-link">
              <ul class="p-0 m-0">
                <li>
                  <a href="https://southlondonremovals.uk/Privacy-Policy/">Privacy Policy</a>
                </li>

                <li>
                  <a href="https://southlondonremovals.uk/About-Us/">About Us</a>
                </li>
                <li>
                  <a href="https://southlondonremovals.uk/GDPR-Statement/">GDPR Statement</a>
                </li>
                <li>
                  <a href="https://southlondonremovals.uk/Terms-&-Conditions/">Terms & Conditions</a>
                </li>
                <li>
                  <a href="https://southlondonremovals.uk/faqs/">FAQs</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="copyright">
          <p class="text-center">
            Copyright © 2025. All Rights Reserved. Powered By <a href="https://okmsolutions.uk/" target="_blank">
              OKM Solutions
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
      </>
    </React.Fragment>
  );
}

export default Footer;
